<template>
  <table class="print-table">
    <thead>
      <tr>
        <th width="24">序号</th>
        <th width="120">商品名称</th>
        <th width="60">材质</th>
        <th width="100">规格(mm)</th>
        <th>单位</th>
        <th>数量</th>
        <th>单价(元)</th>
        <th>金额(元)</th>
        <th width="120">备注</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index) in selfData" :key="index">
        <td>{{ index + 1 }}</td>
        <td>{{ item.craft }}</td>
        <td>{{ item.texture }}</td>
        <td>{{ item.sales_specification }}</td>
        <td>{{ item.unit }}</td>
        <td>{{ item.counts }}</td>
        <td>{{ item.sales_price }}</td>
        <td>{{ item.sales_amount }}</td>
        <td>{{ item.pact_remark }}</td>
      </tr>
      <tr>
        <td>合计</td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>{{ totalCounts }}</td>
        <td></td>
        <td>{{ totalSalesAmount }}</td>
        <td></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfData: [],
      totalCounts: 0,
      totalSalesAmount: 0
    }
  },
  mounted() {
    this.selfData = this.$util.deepCopy(this.data)
    this.totalCounts = this.$util.listFieldTotal(this.selfData, 'counts')
    this.totalSalesAmount = this.$util.listFieldTotal(this.selfData, 'sales_amount')
  }
}
</script>

<style lang="less" scoped>
.print-table {
  margin-top: 5px;
  width: 100%;
  border-collapse: collapse;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
  text-align: center;
}
.print-table th,
.print-table td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
  padding: 2px;
  overflow-wrap: anywhere;
}
.print-table th {
  font-weight: normal;
  background: #e0e5eb;
}
</style>
